// jQuery Version
(($) => {
  if(typeof preferabliConfig === 'undefined') {
    console.error('preferabliConfig is not set');
    return;
  }

  var preferabliGR = $(document.createElement('div')).preferabliGR({
    integration_id: preferabliConfig.integration_id,
    questionnaire_id: preferabliConfig.questionnaire_id || preferabliConfig.collection_id,
    resultsRedirect: preferabliConfig.resultsRedirect,
    showQuestionnaireOnLoad: false,
    opt_out_tracking: true,
    customText: preferabliConfig.customText || {},
    // modal: {
    //   logo: {
    //     position: 'top-left',
    //     content: 'https://example.com/logo.png',
    //     class: 'brand_logo'
    //   }
    // }
  });

  // when onetrust already load
  if(window.OnetrustActiveGroups?.includes('C0002')) {
    preferabliGR.preferabliGR('optOutTracking', false);
  } else {
    preferabliGR.preferabliGR('optOutTracking', true);
  }

  // tracking
  window.OneTrust?.OnConsentChanged(event => {
    const groupIds = event.detail;

    if(Array.isArray(groupIds) && groupIds.length > 0 && groupIds.includes('C0002')) {
      preferabliGR.preferabliGR('optOutTracking', false);
    } else {
      preferabliGR.preferabliGR('optOutTracking', true);
    }
  })

  const element = $('#guidedrec');

  if (element.length > 0) {
    //  To Show Questionnaire Results trigger when DOMReady for results page
    preferabliGR.preferabliGR('show', {
      type: 'results',
      element: $('#guidedrec'),
      layout: 'column',
      productCardsContainer: {
        class: 'irjs__results--row',
        element: 'div',
        id: 'product-cards-container',
      },
      renderProductCards: (lookups) => {
        return Promise.resolve([
            ...lookups.map((lookup) => {
              const { product_name, image_url, intro_text, price, landing_url } = lookup || {};

              return `
                <div class="irjs__card--wrapper irjs__card--compact">
                  <div class="irjs__card irjs__card--product" data-product-id="CE13601">
                      <div class="irjs__sc-19q4yxq-0 gXhMQh irjs__card--inner">
                        <div class="irjs__card--image"><img src="${image_url}" alt="${product_name}"></div>
                        <div class="irjs__card--body">
                            <h3><span>${product_name}</span></h3>

                            <div class="irjs__card--intro-text">${intro_text || ''}</div>
                        </div>
                        <div class="irjs__card--actions"><span class="my-auto">£${price}</span></div>
                        <a href="${landing_url}" aria-label="view ${product_name}" class="btn btn--primary btn--large irjs__card--link"> View Product </a>
                      </div>
                  </div>
                </div>
              `;
            })
        ]);
      },
      onRenderComplete: () => {
        const sidebacktotop = document.querySelector('#sidebacktotop');

        if(!sidebacktotop) {
          return;
        }

        const scrollToTop = (e) => {
          e.preventDefault();
		      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        }

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if(mutation.target.id === 'sidebacktotop' && mutation.attributeName === 'disabled' && mutation.oldValue === null) {
              const rect = sidebacktotop.closest('.irjs__results--outer').getBoundingClientRect();
              sidebacktotop.removeEventListener('click', scrollToTop);

              if(rect.top < 0 && rect.top < -50) {
                sidebacktotop.removeAttribute('disabled');
                sidebacktotop.addEventListener('click', scrollToTop);
              }
            }
          });
        });

        observer.observe(sidebacktotop, {
          subtree: false,
          childList: false,
          attributes: true,
          attributeOldValue: true
        });
      },
    });
  } else {
    $('button#getInstantRec').on('click', (event) => {
      event.preventDefault();
      preferabliGR.preferabliGuidedRec('show');
    });
  }
})(jQuery);